import React from 'react';
import SiteLayout from '../common/SiteLayout';
import Hero from './Hero';
import StatsBar from './StatsBar';
import Problem from './Problem';
import Strategies from './Strategies';
import CarrierChannels from './CarrierChannels';
import SavingsCalculator from './SavingsCalculator';
import Integrations from './Integrations';
import WhyVibe from './WhyVibe';
import Stories from './Stories';
import CTA from './CTA';

const NAV_LINKS = [
  { href: '#how-it-works', label: 'How it works' },
  { href: '#strategies', label: 'Strategies' },
  { href: '#channels', label: 'Channels' },
  { href: '#savings', label: 'Savings' },
  { href: '#integrations', label: 'Integrations' },
  { href: '#stories', label: 'Stories' },
];

const FOOTER_TAGLINE =
  'Vibe Engine automates carrier tendering for shippers — real-time bid visibility, market-rate context, and TMS / ERP / WMS integrations.';

export default function ShippersLanding() {
  return (
    <SiteLayout navLinks={NAV_LINKS} footerTagline={FOOTER_TAGLINE}>
      <Hero />
      <StatsBar />
      <Problem />
      <Strategies />
      <CarrierChannels />
      <SavingsCalculator />
      <Integrations />
      <WhyVibe />
      <Stories />
      <CTA />
    </SiteLayout>
  );
}
